module.exports = __webpack_public_path__ + "static/media/02A.5a3045af.png";